import MainContainer from '../main-container';
import Form from './configurationForm';
import List from './configurationList';
import { paths } from '../../config';

const settings = {
    pathRegister: paths.configurationRegister,
    pathList: paths.configuration,
    apiPath: 'configuration',
    permissionAdmin: null,
    title: 'Configuração',
    entity: 'configuration',
};

const Configuration: React.FC = () => {
    return (
        <MainContainer>
            <Form settings={settings} />
        </MainContainer>
    );
};
const ConfigurationList: React.FC = () => {
    return (
        <MainContainer>
            <List settings={settings} />
        </MainContainer>
    );
};

export { Configuration, ConfigurationList };
